/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CooperativeInputs */

const cs_enum_cooperative = /** @type {(inputs: Enum_CooperativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Družstvo`)
};

const en_enum_cooperative = /** @type {(inputs: Enum_CooperativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cooperative`)
};

/**
* | output |
* | --- |
* | "Cooperative" |
*
* @param {Enum_CooperativeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_cooperative = /** @type {((inputs?: Enum_CooperativeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CooperativeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_cooperative(inputs)
	return cs_enum_cooperative(inputs)
});